// extracted by mini-css-extract-plugin
export var theme_purple = "syntax_themes-module--theme_purple--bTPsa";